module.exports = __webpack_public_path__ + "img/seller.9812e86d.png";